import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  isActive: false,
};

const settingsModalReducer = createSlice({
  name: 'settingsModal',
  initialState: initialState,
  reducers: {
    setIsActive(state, action: PayloadAction<boolean>) {
      state.isActive = action.payload;
    },
  },
});

export const { setIsActive } = settingsModalReducer.actions;
export default settingsModalReducer.reducer;
